// Copyright (c) StrangeBee 2024

import { Route as GlobalTaskList } from './List';

export const Routes = [GlobalTaskList];
